import React, {FC} from 'react'

export const ResetScrollIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='12' cy='12' r='7'/>
        <circle cx='12' cy='12' r='1'/>
        <path d='M12 2v3'/>
        <path d='M12 19v3'/>
        <path d='M2 12h3'/>
        <path d='M19 12h3'/>
    </svg>
)
